module.exports = __webpack_public_path__ + "static/media/icon3.c4fa2aa7.png";